
export default class FlowDiagramTransition {
    constructor (dto) {
        this.id = null;
        this.type = null;
        this.source = null;
        this.destination = null;

        if (dto) {
            this.id = dto.StateFrom;
            this.type = dto.TransitionType === 'V' ? 'Validate' : 'Refuse';
            this.source = { id: dto.StateFrom };
            this.destination = { id: dto.StateTo };
        }
    }
}
